import clsx, { type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Tailwind 클래스 병합 — 경합 유틸 자동 해소. */
export function cn(...classes: ClassValue[]): string {
    return twMerge(clsx(...classes));
}
